import * as React from "react";
import { DayPickerSingleProps } from "react-day-picker";
import { Calendar } from "../ui/calendar";

type FocusedCalendarProps = Omit<
  DayPickerSingleProps,
  "month" | "onMonthChange"
>;

export function FocusedCalendar({ selected, ...props }: FocusedCalendarProps) {
  const [month, setMonth] = React.useState<Date | undefined>(selected);

  React.useEffect(() => {
    if (selected) {
      setMonth(selected);
    }
  }, [selected]);

  return (
    <Calendar
      {...props}
      mode="single"
      selected={selected}
      month={month}
      onMonthChange={setMonth}
    />
  );
}
